
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader, BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { SkeletonLoader, BaseText }
})
export default class HomeBalanceSummaryLoader extends Vue {}
